// Simple i18n setup for Greek language support
// For now, we'll use inline Greek text and later can implement proper i18n

export const locale = 'el-GR'

export const translations = {
  // Navigation
  dashboard: 'Αρχική',
  reservations: {
    title: 'Κρατήσεις',
    new: 'Νέα κράτηση',
    edit: 'Επεξεργασία κράτησης',
    delete: 'Διαγραφή κράτησης',
    confirmed: 'Επιβεβαιωμένες',
    cancelled: 'Ακυρωμένες',
    completed: 'Ολοκληρωμένες',
    noShow: 'Δεν εμφανίστηκε'
  },
  tables: 'Τραπέζια',
  customers: 'Πελάτες',
  settings: 'Ρυθμίσεις',

  // Common actions
  save: 'Αποθήκευση',
  cancel: 'Ακύρωση',
  delete: 'Διαγραφή',
  edit: 'Επεξεργασία',
  add: 'Προσθήκη',
  search: 'Αναζήτηση',

  // Status
  connected: 'Συνδεδεμένο',
  offline: 'Εκτός σύνδεσης',
  synced: 'Συγχρονισμένο',
  localData: 'Τοπικά δεδομένα',

  // Time formats
  today: 'Σήμερα',
  yesterday: 'Χθες',
  tomorrow: 'Αύριο',
}
